import http from "../../http";

const commissionInfo = {
    // 查询店铺分佣记录
    selectCompanyByPage(r) {
        return http.get("/gateway/api/sycompany/pc/CommissionInfoPC/selectCompanyByPage", r)
    },
    // 查询分佣用户记录
    selectCompanyByObjectPage(r) {
        return http.get("/gateway/api/sycompany/pc/CommissionInfoPC/selectCompanyByObjectPage", r)
    },
    // 查询分佣详情
    selectById(r) {
        return http.spin.get("/gateway/api/sycompany/pc/CommissionInfoPC/selectById", r)
    },
    // 佣金结算
    settled(r) {
        return http.spin.post("/gateway/api/sycompany/pc/CommissionInfoPC/settled", r)
    },
    // 发起转账
    createTransfer(r) {
        return http.spin.post("/gateway/api/sycompany/pc/CommissionInfoPC/createTransfer", r)
    },

}
export default commissionInfo
